// 注文受付状態
export const MSG_ORDER_NG = {
  SUSPENDED:
    "申し訳ありません。\nただいま混雑のため注文を一時停止しております。",
  NOT_ACCEPTED:
    "申し訳ありません。\nただいま営業していないため注文できません。",
  IN_CONFIRM:
    "申し訳ありません。\n注文確認中ですのでしばらくお待ちください。",
};

export const MSG_SERVICE = {
  IN_MAINTENANCE:
    "申し訳ありません。\nただいまシステムメンテナンス中のため注文できません。",
};

export const MSG_MENU = {
  CHANGED: "メニューが変更されています。",
};

export const MSG_CART = {
  CHANGED: "カート内のメニューが変更されました。変更されたメニューをカートからクリアして再表示します。",
};

export const MSG_ORDER = {
  INVALID: "この注文は無効です。",
  VISIT_TIME: "申し訳ありません。\n指定した時間では準備することができません。時間設定をもういちどお願いします。",
};

export const MSG_HISTORY = {
  CHANGED: "メニューが変更されているので表示できません。",
  DELETED: "メニューが削除されているので表示できません。",
};
